export default {
  methods: {
    timeLeftUntil(timestamp) {
      const now = new Date();
      const targetDate = new Date(timestamp);

      // Get the difference in milliseconds
      let difference = targetDate - now;

      // If the target date is in the past, return all zeros
      if (difference < 0) {
        return {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        };
      }

      const seconds = Math.floor((difference / 1000) % 60);
      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));

      return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
      };
    },
    formatTimeLeft(timeObj) {
      const { days, hours, minutes, seconds } = timeObj;

      let timeString = '';

      if (days > 0) {
        timeString += `${days}d `;
      }
      if (hours > 0) {
        timeString += `${hours}h `;
      }
      if (minutes > 0) {
        timeString += `${minutes}m `;
      }
      if (seconds > 0 || timeString === '') {
        // Display seconds if there are no other non-zero values
        timeString += `${seconds}s `;
      } else {
        // Remove trailing comma and space
        timeString = timeString.slice(0, -2);
      }

      return timeString;
    }
  }
}
